import { render, staticRenderFns } from "./FreqField.vue?vue&type=template&id=d23ae9d2&"
import script from "./FreqField.vue?vue&type=script&lang=js&"
export * from "./FreqField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports